export const MODULE_ID = 'yadelivery';
export const ADDRESS_INPUT_ID = 'yadelivery-map-address';
export const MAP_CONTAINER_ID = 'yadelivery-map-container';
export const ANIMATION_DURATION = 400;
